import React from 'react';

// Subtle chemistry molecule background pattern - mimics the original alphapro-genetics.pl style
const MoleculeBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden"
      style={{ opacity: 0.22 }}
    >
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
      >
        <defs>
          {/* Quinoline / pyridine fused ring (with N and COOH) */}
          <symbol id="mol-quinoline" viewBox="0 0 220 240">
            <g fill="none" stroke="#1e40af" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              {/* Left benzene */}
              <polygon points="40,80 75,60 110,80 110,120 75,140 40,120" />
              {/* Right pyridine */}
              <polygon points="110,80 145,60 180,80 180,120 145,140 110,120" />
              {/* Double bonds inner */}
              <line x1="48" y1="84" x2="48" y2="116" />
              <line x1="105" y1="84" x2="75" y2="65" />
              <line x1="173" y1="116" x2="173" y2="84" />
              {/* N label */}
              <text x="139" y="155" fontSize="20" fontFamily="serif" fill="#1e40af" stroke="none">N</text>
              {/* COOH up top */}
              <line x1="145" y1="60" x2="145" y2="30" />
              <line x1="145" y1="30" x2="170" y2="20" />
              <line x1="148" y1="25" x2="168" y2="15" />
              <text x="172" y="22" fontSize="16" fontFamily="serif" fill="#1e40af" stroke="none">OH</text>
              <text x="125" y="20" fontSize="16" fontFamily="serif" fill="#1e40af" stroke="none">O</text>
            </g>
          </symbol>

          {/* Chlorinated phenol with methoxy */}
          <symbol id="mol-chlorophenol" viewBox="0 0 240 200">
            <g fill="none" stroke="#1e40af" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="80,60 120,40 160,60 160,100 120,120 80,100" />
              {/* Inner double bonds */}
              <line x1="88" y1="65" x2="88" y2="95" />
              <line x1="155" y1="65" x2="125" y2="48" />
              <line x1="125" y1="112" x2="155" y2="95" />
              {/* Cl */}
              <line x1="160" y1="60" x2="190" y2="40" />
              <text x="192" y="38" fontSize="18" fontFamily="serif" fill="#1e40af" stroke="none">Cl</text>
              {/* OH */}
              <line x1="80" y1="100" x2="50" y2="120" />
              <text x="20" y="130" fontSize="18" fontFamily="serif" fill="#1e40af" stroke="none">HO</text>
              {/* OCH3 */}
              <line x1="160" y1="100" x2="190" y2="120" />
              <text x="192" y="130" fontSize="18" fontFamily="serif" fill="#1e40af" stroke="none">O</text>
              <line x1="208" y1="128" x2="225" y2="138" />
            </g>
          </symbol>

          {/* Simple steroid-like hexagons */}
          <symbol id="mol-steroid" viewBox="0 0 280 160">
            <g fill="none" stroke="#1e40af" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="20,60 50,40 80,60 80,100 50,120 20,100" />
              <polygon points="80,60 110,40 140,60 140,100 110,120 80,100" />
              <polygon points="140,60 170,40 200,60 200,100 170,120 140,100" />
              <polygon points="200,60 230,40 260,60 260,100 230,120 200,100" />
              <line x1="50" y1="40" x2="50" y2="20" />
              <line x1="170" y1="40" x2="170" y2="20" />
            </g>
          </symbol>

          {/* Simple benzene */}
          <symbol id="mol-benzene" viewBox="0 0 120 120">
            <g fill="none" stroke="#1e40af" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="30,40 60,22 90,40 90,80 60,98 30,80" />
              <circle cx="60" cy="60" r="18" />
            </g>
          </symbol>
        </defs>

        {/* Sparsely scattered molecules - tiled across viewport */}
        <use href="#mol-quinoline" x="-2%" y="2%" width="180" height="200" />
        <use href="#mol-chlorophenol" x="78%" y="6%" width="210" height="170" />
        <use href="#mol-benzene" x="42%" y="14%" width="110" height="110" />
        <use href="#mol-steroid" x="55%" y="38%" width="260" height="140" />
        <use href="#mol-quinoline" x="3%" y="42%" width="170" height="190" />
        <use href="#mol-chlorophenol" x="80%" y="58%" width="200" height="160" />
        <use href="#mol-benzene" x="22%" y="68%" width="100" height="100" />
        <use href="#mol-quinoline" x="60%" y="78%" width="180" height="200" />
        <use href="#mol-steroid" x="-2%" y="86%" width="240" height="130" />
        <use href="#mol-chlorophenol" x="38%" y="92%" width="210" height="170" />
        <use href="#mol-benzene" x="86%" y="92%" width="110" height="110" />
      </svg>
    </div>
  );
};

export default MoleculeBackground;
